import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_3 = { class: "max-w-[1040px]" }
const _hoisted_4 = { class: "grid gap-5 sm:grid-cols-2" }
const _hoisted_5 = { class: "py-2 text-sm text-gray-900" }
const _hoisted_6 = { class: "grid gap-5 sm:grid-cols-2" }
const _hoisted_7 = { class: "flex flex-col gap-3" }
const _hoisted_8 = { class: "max-w-[1180px]" }
const _hoisted_9 = { class: "max-w-[1040px]" }
const _hoisted_10 = { class: "flex items-center justify-between gap-6 border-t border-gray-100 pt-5" }
const _hoisted_11 = { class: "flex items-center gap-4" }
const _hoisted_12 = { class: "flex-1 min-w-0" }
const _hoisted_13 = {
  key: 0,
  class: "max-w-[1040px]"
}
const _hoisted_14 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_15 = { class: "flex items-center justify-between gap-6" }
const _hoisted_16 = {
  key: 0,
  "data-test": "zone-locked",
  class: "m-0 text-sm text-gray-600"
}
const _hoisted_17 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}
const _hoisted_18 = { class: "flex items-center gap-1 rounded-full border border-gray-300 py-0.5 pl-2.5 pr-1 text-sm text-gray-700" }
const _hoisted_19 = {
  key: 1,
  class: "text-sm italic text-gray-500"
}
const _hoisted_20 = {
  key: 2,
  "data-test": "zone-locked",
  class: "m-0 text-sm text-gray-600"
}
const _hoisted_21 = {
  key: 3,
  "data-test": "add-zone",
  class: "flex gap-3"
}
const _hoisted_22 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}
const _hoisted_23 = { class: "flex items-center gap-1 rounded-full border border-gray-300 py-0.5 pl-2.5 pr-1 text-sm text-gray-700" }
const _hoisted_24 = {
  key: 1,
  class: "text-sm italic text-gray-500"
}
const _hoisted_25 = {
  key: 2,
  "data-test": "zone-locked",
  class: "m-0 text-sm text-gray-600"
}
const _hoisted_26 = {
  key: 3,
  "data-test": "add-zone",
  class: "flex gap-3"
}
const _hoisted_27 = { class: "flex-1 min-w-0" }
const _hoisted_28 = { class: "max-w-[1040px]" }
const _hoisted_29 = { class: "flex gap-3" }
const _hoisted_30 = { class: "flex-1 min-w-0" }
const _hoisted_31 = {
  key: 0,
  class: "-mb-3 divide-y divide-gray-100 border-t border-gray-100"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "font-semibold text-gray-700" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "font-semibold text-gray-700" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "font-semibold text-gray-700" }
const _hoisted_38 = { class: "max-w-[1040px]" }
const _hoisted_39 = {
  key: 0,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_40 = { class: "flex justify-end -m-1" }
const _hoisted_41 = { class: "text-gray-900" }
const _hoisted_42 = { class: "truncate" }
const _hoisted_43 = { class: "flex justify-end" }
const _hoisted_44 = { class: "max-w-[1040px]" }
const _hoisted_45 = { class: "flex items-center justify-between gap-6 border-t border-gray-100 pt-5" }
const _hoisted_46 = { class: "sm:max-w-xs" }
const _hoisted_47 = { class: "flex items-center gap-2" }

import { XCircleIcon } from '@heroicons/vue/24/outline'
import { computed, reactive, ref, toRaw, watch } from 'vue'
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import InputError from '@/components/forms/InputError.vue'
import GoogleMapComponent from '@/components/GoogleMapComponent'
import { useRouteTabs } from '@/composables/useRouteTabs'
import { useToast } from '@/composables/useToast'
import { dateObjectToServerDay } from '@/helpers/dates'
import { affectedDropsFrom, affectedDropsToastMessage } from '@/helpers/dropImpact'
import { parseZipCodes } from '@/helpers/zipCodes'
import australiaStates from '@/models/australiaStates'
import canadianStates from '@/models/canadianStates'
import { fulfillmentTypeLabel } from '@/models/fulfillmentMethodTypes'
import unitedKingdomStates from '@/models/unitedKingdomStates'
import usaStates from '@/models/usaStates'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'

const UBER_DIRECT_DEFAULT_RADIUS_MILES = 10
const MILES_TO_METERS = 1609.344

export default {
  __name: 'FulfillmentMethodNeue',
  setup(__props) {

const store = useStore()
const route = useRoute()
const router = useRouter()
const { showToast } = useToast()
const loading = ref(true)
const hasUnsavedChanges = ref(false)
const nameError = ref(false)

const onFulfillmentMethodNameInput = () => {
  hasUnsavedChanges.value = true
  nameError.value = false
}

const allStates = computed(() =>
  (
    ({ USA: usaStates, AUS: australiaStates, CAN: canadianStates, GBR: unitedKingdomStates })[store.getters.country] ??
    []
  ).map(x => ({
    name: x.label,
    value: x.value
  }))
)
const zipName = computed(
  () => ({ USA: 'ZIP code', AUS: 'postcode', CAN: 'postcode', GBR: 'postcode' })[store.getters.country]
)
const capitalizedZipName = computed(
  () => ({ USA: 'ZIP code', AUS: 'Postcode', CAN: 'Postcode', GBR: 'Postcode' })[store.getters.country]
)
const stateLabel = computed(
  () => ({ USA: 'State', AUS: 'State', CAN: 'Province', GBR: 'County' })[store.getters.country]
)
const zipLength = computed(() => ({ USA: 5, AUS: 4, CAN: 7, GBR: 7 })[store.getters.country])

const restrictionModalOpen = ref(false)
const reminderModal = reactive({ open: false })
const basics = ref({})
const address = ref({ state: null })
const backup = ref(null)
const addingZip = ref('')
const addingState = ref(null)
const addingRestriction = ref(null)
const editingRestriction = ref({})
const editingDiscount = ref({})
const selectedStores = ref({})
const polygon = ref(null)

const stateName = state => allStates.value.find(x => x.value === state)?.name ?? state

const stores = computed(() => mapType('store'))
const tiers = computed(() => mapType('membership_tier'))
const method = computed(() => mapRelationship({ type: 'fulfillment_method', id: route.params.id }))
const isUberDirect = computed(() => method.value?.attributes.type === 'UberDirectFulfillmentMethod')
const isPickup = computed(() => method.value?.attributes.type === 'PickupFulfillmentMethod')
const pickupAddress = computed(() => mapRelationship(method.value?.relationships.delivery_address.data))
const pickupCoords = computed(() => {
  const lat = pickupAddress.value?.attributes.latitude
  const lng = pickupAddress.value?.attributes.longitude
  return typeof lat === 'number' && typeof lng === 'number' ? [lat, lng] : null
})
const radiusMeters = computed(
  () => (method.value?.attributes.uber_direct_radius_miles ?? UBER_DIRECT_DEFAULT_RADIUS_MILES) * MILES_TO_METERS
)

const methodTabs = computed(() =>
  [
    { id: 'main', name: 'Main info' },
    { id: 'slots', name: 'Fulfillment slots' },
    { id: 'pricing', name: 'Pricing' },
    !isPickup.value && { id: 'zones', name: isUberDirect.value ? 'Delivery radius' : 'Fulfillment zones' },
    { id: 'restrictions', name: 'Restrictions' },
    { id: 'reminders', name: 'Reminders' },
    { id: 'advanced', name: 'Advanced settings' }
  ].filter(Boolean)
)
const { activeTab, sections: methodSections } = useRouteTabs(
  methodTabs,
  computed(() => `/store/fulfillment-methods/${route.params.id}`)
)

const zoneMapsMounted = ref(false)
watch(
  activeTab,
  tab => {
    if (tab === 'zones') zoneMapsMounted.value = true
  },
  { immediate: true }
)
watch([polygon, pickupCoords, radiusMeters], () => {
  if (activeTab.value !== 'zones') zoneMapsMounted.value = false
})

const reminderColumns = [{ width: 'minmax(180px, 1fr)' }, { width: 'minmax(160px, 1.5fr)' }, { width: '140px' }]

const backupOptions = computed(() => [
  { name: 'None', value: null },
  ...mapType('fulfillment_method')
    .filter(x => x.id != method.value?.id)
    .map(x => ({ name: x.attributes.name, value: x.id }))
])
const eligibleZips = computed(
  () =>
    method.value?.attributes.eligible_zip_codes
      .map(x => x.split(','))
      .flat()
      .map(x => x.trim())
      .sort() ?? []
)
const eligibleStates = computed(
  () => method.value?.attributes.eligible_states.sort((a, b) => stateName(a).localeCompare(stateName(b))) ?? []
)
const zoneLockNotes = computed(() => {
  const inUse = {
    map: !!basics.value.map,
    zips: eligibleZips.value.length > 0,
    states: eligibleStates.value.length > 0
  }
  const clearStep = {
    map: 'turn off the map region',
    zips: `remove every ${zipName.value}`,
    states: `remove every ${stateLabel.value.toLowerCase()}`
  }
  const noun = { map: 'a map region', zips: zipName.value, states: stateLabel.value.toLowerCase() }
  return Object.fromEntries(
    Object.keys(inUse).map(kind => {
      const steps = Object.keys(inUse).filter(other => other !== kind && inUse[other])
      if (!steps.length || (kind === 'map' && inUse.map)) return [kind, null]
      const sentence = `${steps.map(other => clearStep[other]).join(' and ')} to limit this method by ${noun[kind]} instead.`
      return [kind, sentence[0].toUpperCase() + sentence.slice(1)]
    })
  )
})
const restrictions = computed(() =>
  mapRelationships(method.value?.relationships.restrictions.data).sort((a, b) => a.id - b.id)
)
const fulfillmentDiscount = computed(() => mapRelationship(method.value?.relationships.fulfillment_discount.data))

watch(
  fulfillmentDiscount,
  newDiscount => {
    if (newDiscount && !editingDiscount.value.id) {
      editingDiscount.value = {
        id: newDiscount.id,
        type: newDiscount.attributes.type,
        value: (
          newDiscount.attributes.value / (newDiscount.attributes.type === 'AmountFulfillmentDiscount' ? 100 : 1)
        ).toFixed(2)
      }
    }
  },
  { immediate: true }
)

const onZipInput = () => {
  if (addingZip.value.split(',').length > 1) {
    const zips = parseZipCodes(addingZip.value, zipLength.value, eligibleZips.value)
    if (zips.length) {
      api.call('PUT', `fulfillment_methods/${route.params.id}`, {
        fulfillment_method: { eligible_zip_codes: [...eligibleZips.value, ...zips] }
      })
    }
    addingZip.value = ''
    return
  }
  addingZip.value = addingZip.value.replace(/\D/g, '').slice(0, zipLength.value)
}

const addZip = () => {
  if (addingZip.value.length !== zipLength.value || eligibleZips.value.some(x => x === addingZip.value)) return
  api.call('PUT', `fulfillment_methods/${route.params.id}`, {
    fulfillment_method: { eligible_zip_codes: [...eligibleZips.value, addingZip.value] }
  })
  addingZip.value = ''
}

const addRestriction = () => {
  api
    .call('PUT', `fulfillment_methods/${route.params.id}?included=restrictions`, {
      fulfillment_method: {
        restrictions_attributes: [
          {
            restriction_class_name: 'MembershipTier',
            type_of_restriction: addingRestriction.value === 'tier' ? 'membership_tier' : 'cart_total'
          }
        ]
      }
    })
    .then(x => {
      editRestriction(
        mapRelationships(x.data.data.relationships.restrictions.data)
          .sort((a, b) => a.id - b.id)
          .pop()
      )
      editingRestriction.value.new = true
    })
}

const closeRestrictionModal = () => {
  if (editingRestriction.value.new) deleteRestriction(editingRestriction.value)
  restrictionModalOpen.value = false
}

const deleteRestriction = restriction => {
  api.call('PUT', `fulfillment_methods/${route.params.id}?included=restrictions`, {
    fulfillment_method: {
      restrictions_attributes: [
        {
          id: restriction.id,
          _destroy: true
        }
      ]
    }
  })
}

const editRestriction = restriction => {
  editingRestriction.value = {
    id: restriction.id,
    type: restriction.attributes.type_of_restriction,
    tierId: restriction.attributes.restriction_id?.toString() ?? null,
    cartValue: (restriction.attributes.integer_value / 100).toFixed(2)
  }
  restrictionModalOpen.value = true
}

const saveRestriction = () => {
  api.call('PUT', `fulfillment_methods/${route.params.id}?included=restrictions`, {
    fulfillment_method: {
      restrictions_attributes: [
        {
          id: editingRestriction.value.id,
          restriction_id: editingRestriction.value.tierId,
          integer_value: editingRestriction.value.cartValue * 100
        }
      ]
    }
  })
  restrictionModalOpen.value = false
}

const onDiscountTypeChange = () => {
  if (editingDiscount.value.type && !fulfillmentDiscount.value) {
    editingDiscount.value.value = '0.00'
    hasUnsavedChanges.value = true
  } else if (editingDiscount.value.type && fulfillmentDiscount.value) {
    hasUnsavedChanges.value = true
  }
}

const deleteDiscount = () => {
  api
    .call('PUT', `fulfillment_methods/${route.params.id}?included=fulfillment_discount`, {
      fulfillment_method: {
        fulfillment_discount_attributes: {
          id: fulfillmentDiscount.value.id,
          _destroy: true
        }
      }
    })
    .then(() => {
      if (fulfillmentDiscount.value) {
        store.commit('DESTROY_OBJECT', { data: fulfillmentDiscount.value })
      }
      editingDiscount.value = { type: null, value: '' }
      hasUnsavedChanges.value = false
    })
}

const removeZip = zip => {
  api.call('PUT', `fulfillment_methods/${route.params.id}`, {
    fulfillment_method: { eligible_zip_codes: eligibleZips.value.filter(x => x !== zip) }
  })
}

const addState = () => {
  if (!addingState.value) return
  api.call('PUT', `fulfillment_methods/${route.params.id}`, {
    fulfillment_method: { eligible_states: [...eligibleStates.value, addingState.value] }
  })
  addingState.value = null
}

const removeState = state => {
  api.call('PUT', `fulfillment_methods/${route.params.id}`, {
    fulfillment_method: { eligible_states: eligibleStates.value.filter(x => x !== state) }
  })
}

const slots = computed(() =>
  mapType('fulfillment_slot').filter(x => x.relationships?.fulfillment_method?.data?.id == route.params.id)
)

const slotsForDay = day => slots.value.filter(x => x.attributes.fulfillment_date === dateObjectToServerDay(day))

const getSlots = days => {
  for (const day of days) {
    for (const slot of slotsForDay(day)) {
      store.commit('DESTROY_OBJECT', { data: slot })
    }
  }
  const from = dateObjectToServerDay(days.at(0))
  const to = dateObjectToServerDay(days.at(-1))
  return api.call(
    'GET',
    `fulfillment_methods/${route.params.id}/fulfillment_slots?date_from=${from}&date_to=${to}&included=duplicator,fulfillment_availabilities`
  )
}

const reminders = computed(() =>
  mapRelationships(method.value?.relationships.fulfillment_reminder_message_automations.data)
)
const reminderTemplate = reminder => mapRelationship(reminder.relationships.message_template.data)
const addReminder = async () => {
  await api.call(
    'PUT',
    `fulfillment_methods/${route.params.id}?included=fulfillment_reminder_message_automations,fulfillment_reminder_message_automations.message_template`,
    {
      fulfillment_method: {
        fulfillment_reminder_message_automations_attributes: [
          {
            offset_type: 'minutes',
            offset_value: 0,
            message_template_attributes: { body: 'Reminder text goes here.' }
          }
        ]
      }
    }
  )
  openReminderModal(reminders.value.at(-1), true)
}
const deleteReminder = async reminder => {
  await api.call('PUT', `fulfillment_methods/${route.params.id}?included=fulfillment_reminder_message_automations`, {
    fulfillment_method: { fulfillment_reminder_message_automations_attributes: [{ _destroy: true, id: reminder.id }] }
  })
}
const reminderFormat = reminder => {
  let value = reminder.attributes.offset_value
  if (reminder.attributes.offset_type === 'hours') value *= 60
  if (reminder.attributes.offset_type === 'days') value *= 60 * 24
  const days = Math.floor(value / (60 * 24))
  const multiplier = Math.sign(days)
  const absdays = Math.abs(days)
  const minutes = value - 60 * 24 * days
  let string = ''
  let hours = Math.floor(minutes / 60) % 12
  if (hours === 0) hours = 12
  string += hours
  string += ':'
  string += String(minutes % 60).padStart(2, 0)
  string += Math.floor(minutes / 60) >= 12 ? ' PM' : ' AM'
  string += ', '
  if (multiplier === 0) string += 'day of'
  if (multiplier !== 0) string += absdays + ' days '
  if (multiplier === 1) string += 'after'
  if (multiplier === -1) string += 'before'
  if (multiplier !== 0) string += ' the arrival day'
  return string
}
const openReminderModal = (reminder, nu) => {
  reminderModal.reminder = reminder
  reminderModal.new = Boolean(nu)
  reminderModal.open = true
  if (reminderModal.new) {
    reminderModal.multiplier = 0
    reminderModal.days = ''
    reminderModal.time = '00:00'
    reminderModal.body = ''
  } else {
    let value = reminder.attributes.offset_value
    if (reminder.attributes.offset_type === 'hours') value *= 60
    if (reminder.attributes.offset_type === 'days') value *= 60 * 24
    const days = Math.floor(value / (60 * 24))
    reminderModal.multiplier = Math.sign(days)
    reminderModal.days = Math.abs(days)
    const minutes = value - 60 * 24 * reminderModal.days * reminderModal.multiplier
    reminderModal.time = String(Math.floor(minutes / 60)).padStart(2, 0) + ':' + String(minutes % 60).padStart(2, 0)
    reminderModal.body = mapRelationship(reminder.relationships.message_template.data).attributes.body
  }
}
const closeReminderModal = () => {
  if (reminderModal.new) deleteReminder(reminderModal.reminder)
  reminderModal.open = false
}
const saveReminderModal = () => {
  const hours = Number(reminderModal.time.split(':')[0])
  const minutes = Number(reminderModal.time.split(':')[1])
  api.call(
    'PUT',
    `fulfillment_methods/${route.params.id}?included=fulfillment_reminder_message_automations,fulfillment_reminder_message_automations.message_template`,
    {
      fulfillment_method: {
        fulfillment_reminder_message_automations_attributes: [
          {
            id: reminderModal.reminder.id,
            offset_type: 'minutes',
            offset_value: (reminderModal.days ?? 0) * 60 * 24 * reminderModal.multiplier + hours * 60 + minutes,
            message_template_attributes: { body: reminderModal.body }
          }
        ]
      }
    }
  )
  reminderModal.open = false
}

const discard = () => {
  basics.value = {
    name: method.value.attributes.name,
    description: method.value.attributes.description,
    order: method.value.attributes.order,
    price: (method.value.attributes.price.cents / 100).toFixed(2),
    taxable: method.value.attributes.taxable,
    map: method.value.attributes.use_bounding_polygon_waypoints,
    hideTimes: method.value.attributes.hide_times
  }
  backup.value = method.value?.relationships.backup_fulfillment_method.data?.id ?? null
  address.value = structuredClone(
    toRaw(mapRelationship(method.value.relationships.delivery_address.data)?.attributes)
  ) ?? { state: null }
  selectedStores.value = {}
  for (const pair of mapRelationships(method.value.relationships.fulfillment_method_store_pairs.data)) {
    selectedStores.value[pair.attributes.store_id] = true
  }
  polygon.value = method.value.attributes.bounding_polygon_waypoints

  if (fulfillmentDiscount.value) {
    editingDiscount.value = {
      id: fulfillmentDiscount.value.id,
      type: fulfillmentDiscount.value.attributes.type,
      value: (
        fulfillmentDiscount.value.attributes.value /
        (fulfillmentDiscount.value.attributes.type === 'AmountFulfillmentDiscount' ? 100 : 1)
      ).toFixed(2)
    }
  } else {
    editingDiscount.value = { type: null, value: '' }
  }

  hasUnsavedChanges.value = false
}

const submit = () => {
  if (!basics.value.name || !basics.value.name.trim()) {
    nameError.value = true
    return
  }

  const fulfillmentMethodData = {
    name: basics.value.name,
    description: basics.value.description,
    order: basics.value.order,
    price_cents: Math.round(basics.value.price * 100),
    taxable: basics.value.taxable,
    delivery_address_attributes: address.value,
    fulfillment_method_store_pairs_attributes: [
      ...method.value.relationships.fulfillment_method_store_pairs.data.map(x => ({ _destroy: true, id: x.id })),
      ...Object.entries(selectedStores.value)
        .filter(([k, v]) => v)
        .map(([k, v]) => ({ store_id: k }))
    ],
    backup_fulfillment_method_id: backup.value,
    use_bounding_polygon_waypoints: basics.value.map,
    bounding_polygon_waypoints: polygon.value,
    hide_times: basics.value.hideTimes
  }

  if (editingDiscount.value && editingDiscount.value.type) {
    fulfillmentMethodData.fulfillment_discount_attributes = {
      id: editingDiscount.value.id || null,
      type: editingDiscount.value.type,
      value:
        editingDiscount.value.type === 'AmountFulfillmentDiscount'
          ? Math.round(editingDiscount.value.value * 100)
          : Math.round(editingDiscount.value.value)
    }
  }

  api
    .call('PUT', `fulfillment_methods/${route.params.id}?included=fulfillment_discount`, {
      fulfillment_method: fulfillmentMethodData
    })
    .then(() => {
      editingDiscount.value = fulfillmentDiscount.value
        ? {
            id: fulfillmentDiscount.value.id,
            type: fulfillmentDiscount.value.attributes.type,
            value: (
              fulfillmentDiscount.value.attributes.value /
              (fulfillmentDiscount.value.attributes.type === 'AmountFulfillmentDiscount' ? 100 : 1)
            ).toFixed(2)
          }
        : { type: null, value: '' }
      hasUnsavedChanges.value = false
    })
}

const deleteMethod = () => {
  if (!confirm(`Delete ${basics.value.name}?`)) return
  api.call('DELETE', `fulfillment_methods/${route.params.id}`).then(response => {
    const drops = affectedDropsFrom(response)
    if (drops.length) showToast(affectedDropsToastMessage(drops), { type: 'warning', duration: 8000 })
    router.push('/store/fulfillment-methods')
  })
}

const load = async id => {
  // TODO(alicja): make loading state more granular
  await Promise.all([
    api.call('GET', 'fulfillment_methods?included=none'),
    api.call(
      'GET',
      `fulfillment_methods/${id}?included=${['restrictions', 'delivery_address', 'fulfillment_method_store_pairs', 'fulfillment_reminder_message_automations', 'fulfillment_reminder_message_automations.message_template', 'fulfillment_discount'].join(',')}`
    )
  ])
  discard()
  loading.value = false
  api.call('GET', 'membership_tiers?included=none')
}

load(route.params.id)
onBeforeRouteUpdate((to, from) => {
  if (to.params.id === from.params.id) return
  loading.value = true
  load(to.params.id)
})

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_SaveBar = _resolveComponent("SaveBar")
  const _component_InputField = _resolveComponent("InputField")
  const _component_InputArea = _resolveComponent("InputArea")
  const _component_SettingsSection = _resolveComponent("SettingsSection")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_FulfillmentSlotCalendar = _resolveComponent("FulfillmentSlotCalendar")
  const _component_NeueToggle = _resolveComponent("NeueToggle")
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_TablistGrid = _resolveComponent("TablistGrid")
  const _component_TablistHeader = _resolveComponent("TablistHeader")
  const _component_TablistRow = _resolveComponent("TablistRow")
  const _component_NeueTablist = _resolveComponent("NeueTablist")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_FormElement = _resolveComponent("FormElement")
  const _component_FormSection = _resolveComponent("FormSection")
  const _component_TheModal = _resolveComponent("TheModal")
  const _component_PageFooter = _resolveComponent("PageFooter")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, {
        text: basics.value.name,
        "save-status": true,
        sections: _unref(methodSections)
      }, null, 8, ["text", "sections"]),
      _createVNode(_component_SaveBar, {
        "has-unsaved-changes": hasUnsavedChanges.value,
        onOnDiscard: discard,
        onOnSave: submit
      }, null, 8, ["has-unsaved-changes"])
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_NeueLoading, { loading: loading.value }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_3, [
                _createVNode(_component_SettingsSection, {
                  title: "Details",
                  description: "The name and description customers see for this method at checkout."
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_InputField, {
                          modelValue: basics.value.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((basics.value.name) = $event)),
                          name: "Fulfillment method name",
                          error: nameError.value,
                          onInput: onFulfillmentMethodNameInput
                        }, null, 8, ["modelValue", "error"]),
                        (nameError.value)
                          ? (_openBlock(), _createBlock(InputError, {
                              key: 0,
                              "error-message": "Fulfillment method name is required"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[44] || (_cache[44] = _createElementVNode("p", { class: "text-sm font-medium text-gray-700 mb-1" }, "Fulfillment method type", -1)),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(fulfillmentTypeLabel)(method.value?.attributes.type)), 1)
                      ])
                    ]),
                    _createVNode(_component_InputArea, {
                      modelValue: basics.value.description,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((basics.value.description) = $event)),
                      name: "Description",
                      placeholder: "A description that shows up underneath the name for the customer",
                      onInput: _cache[2] || (_cache[2] = $event => (hasUnsavedChanges.value = true))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (isUberDirect.value)
                  ? (_openBlock(), _createBlock(_component_SettingsSection, {
                      key: 0,
                      title: "Uber Direct",
                      description: "Uber Direct couriers deliver these orders."
                    }, {
                      default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                        _createElementVNode("ul", { class: "list-disc pl-5 space-y-2 text-sm leading-relaxed text-gray-600" }, [
                          _createElementVNode("li", null, " Set the pickup address below. Couriers collect from it and Uber quotes each order from there. Addresses outside the delivery radius Uber allows for your area are not offered a slot. "),
                          _createElementVNode("li", null, " The courier fee is quoted at checkout and shown to the customer as part of the normal delivery fee. Customers never see Uber mentioned. Who pays it is set under Store settings, Fees. "),
                          _createElementVNode("li", null, " A courier is booked automatically as soon as the order is paid. Changing the slot or address rebooks it; editing items does not. The fee is not refundable. "),
                          _createElementVNode("li", null, "Any price you set on this method is your own handling fee on top of the courier fee.")
                        ], -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_SettingsSection, {
                  title: isUberDirect.value ? 'Pickup address' : 'Address',
                  description: 
                  isUberDirect.value
                    ? 'The address where the Uber courier picks up the order.'
                    : 'The address this method runs from, such as a pickup location.'
                
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_InputField, {
                        modelValue: address.value.address1,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((address.value.address1) = $event)),
                        name: "Address line 1",
                        placeholder: "123 Cherry St",
                        onInput: _cache[4] || (_cache[4] = $event => (hasUnsavedChanges.value = true))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_InputField, {
                        modelValue: address.value.address2,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((address.value.address2) = $event)),
                        name: "Address line 2",
                        placeholder: "Unit A",
                        onInput: _cache[6] || (_cache[6] = $event => (hasUnsavedChanges.value = true))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_InputField, {
                        modelValue: address.value.city,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((address.value.city) = $event)),
                        name: "City",
                        placeholder: "Springfield",
                        onInput: _cache[8] || (_cache[8] = $event => (hasUnsavedChanges.value = true))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_SelectInput, {
                        modelValue: address.value.state,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((address.value.state) = $event)),
                        name: stateLabel.value,
                        placeholder: `Choose a ${stateLabel.value.toLowerCase()}`,
                        options: allStates.value,
                        onChange: _cache[10] || (_cache[10] = $event => (hasUnsavedChanges.value = true))
                      }, null, 8, ["modelValue", "name", "placeholder", "options"]),
                      _createVNode(_component_InputField, {
                        modelValue: address.value.zip,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((address.value.zip) = $event)),
                        name: capitalizedZipName.value,
                        placeholder: { USA: '10001', AUS: '2000', CAN: 'V5K 0A1', GBR: 'SW1 9AJ' }[_unref(store).getters.country],
                        onInput: _cache[12] || (_cache[12] = $event => (hasUnsavedChanges.value = true))
                      }, null, 8, ["modelValue", "name", "placeholder"])
                    ])
                  ]),
                  _: 1
                }, 8, ["title", "description"]),
                _createVNode(_component_SettingsSection, {
                  title: "Stores",
                  description: "Stores where this method is available."
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stores.value, (store) => {
                        return (_openBlock(), _createBlock(_component_Checkbox, {
                          key: store.id,
                          modelValue: selectedStores.value[store.id],
                          "onUpdate:modelValue": $event => ((selectedStores.value[store.id]) = $event),
                          name: store.attributes.store_name,
                          description: store.attributes.store_description,
                          onChange: _cache[13] || (_cache[13] = $event => (hasUnsavedChanges.value = true))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "description"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _unref(activeTab) === 'main']
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_8, [
                _createVNode(_component_SettingsSection, {
                  title: "Fulfillment slots",
                  description: "The windows customers can pick from for this method. Click a slot to edit it."
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FulfillmentSlotCalendar, {
                      slots: slots.value,
                      "fulfillment-method": method.value,
                      editable: true,
                      onGetSlots: getSlots
                    }, null, 8, ["slots", "fulfillment-method"])
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _unref(activeTab) === 'slots']
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_9, [
                _createVNode(_component_SettingsSection, {
                  title: "Price",
                  description: 
                  isUberDirect.value
                    ? 'Your own handling fee, charged on top of the Uber courier fee.'
                    : 'What customers pay when they choose this method.'
                
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputField, {
                      modelValue: basics.value.price,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((basics.value.price) = $event)),
                      prefix: "$",
                      name: "Price",
                      placeholder: "0.00",
                      class: "sm:max-w-xs",
                      onInput: _cache[15] || (_cache[15] = $event => (hasUnsavedChanges.value = true))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[46] || (_cache[46] = _createElementVNode("div", { class: "min-w-0" }, [
                        _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Taxable"),
                        _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, "Charge tax on this method's price.")
                      ], -1)),
                      _createVNode(_component_NeueToggle, {
                        modelValue: basics.value.taxable,
                        "onUpdate:modelValue": [
                          _cache[16] || (_cache[16] = $event => ((basics.value.taxable) = $event)),
                          _cache[17] || (_cache[17] = $event => (hasUnsavedChanges.value = true))
                        ]
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }, 8, ["description"]),
                _createVNode(_component_SettingsSection, {
                  title: "Fulfillment discount",
                  description: "A discount taken off orders that use this method at checkout."
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_SelectInput, {
                          modelValue: editingDiscount.value.type,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((editingDiscount.value.type) = $event)),
                          placeholder: "Choose a discount type",
                          options: [
                        { name: 'Dollar amount', value: 'AmountFulfillmentDiscount' },
                        { name: 'Percentage amount', value: 'PercentFulfillmentDiscount' }
                      ],
                          onChange: onDiscountTypeChange
                        }, null, 8, ["modelValue"])
                      ]),
                      (editingDiscount.value.type)
                        ? (_openBlock(), _createBlock(_component_InputField, {
                            key: 0,
                            modelValue: editingDiscount.value.value,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => ((editingDiscount.value.value) = $event)),
                            prefix: editingDiscount.value.type === 'AmountFulfillmentDiscount' ? '$' : '',
                            suffix: editingDiscount.value.type === 'PercentFulfillmentDiscount' ? '%' : '',
                            placeholder: "0.00",
                            class: "flex-1 min-w-0",
                            onInput: _cache[20] || (_cache[20] = $event => (hasUnsavedChanges.value = true))
                          }, null, 8, ["modelValue", "prefix", "suffix"]))
                        : _createCommentVNode("", true),
                      (fulfillmentDiscount.value)
                        ? (_openBlock(), _createBlock(_unref(XCircleIcon), {
                            key: 1,
                            class: "h-5 w-5 shrink-0 cursor-pointer text-gray-700",
                            onClick: deleteDiscount
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _unref(activeTab) === 'pricing']
              ]),
              (!isPickup.value)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (isUberDirect.value)
                      ? (_openBlock(), _createBlock(_component_SettingsSection, {
                          key: 0,
                          title: "Delivery radius",
                          description: "Uber delivers within this radius of the pickup address. Customers outside it are not offered this method."
                        }, {
                          default: _withCtx(() => [
                            (!pickupCoords.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Save a pickup address to see the delivery radius. "))
                              : (zoneMapsMounted.value)
                                ? (_openBlock(), _createBlock(_unref(GoogleMapComponent), {
                                    key: 1,
                                    mode: "radius",
                                    center: pickupCoords.value,
                                    "radius-meters": radiusMeters.value
                                  }, null, 8, ["center", "radius-meters"]))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_SettingsSection, {
                            title: "Map region",
                            description: "Only customers inside the region you draw can choose this method."
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_15, [
                                _cache[47] || (_cache[47] = _createElementVNode("div", { class: "min-w-0" }, [
                                  _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Eligible region on a map"),
                                  _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Turn on to limit this method to the region drawn below. ")
                                ], -1)),
                                (!zoneLockNotes.value.map)
                                  ? (_openBlock(), _createBlock(_component_NeueToggle, {
                                      key: 0,
                                      modelValue: basics.value.map,
                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => ((basics.value.map) = $event)),
                                      onChange: _cache[22] || (_cache[22] = $event => (hasUnsavedChanges.value = true))
                                    }, null, 8, ["modelValue"]))
                                  : _createCommentVNode("", true)
                              ]),
                              (zoneLockNotes.value.map)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(zoneLockNotes.value.map), 1))
                                : _createCommentVNode("", true),
                              (polygon.value && zoneMapsMounted.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(["border-t border-gray-100 pt-5", !basics.value.map && 'cursor-not-allowed'])
                                  }, [
                                    _createVNode(_unref(GoogleMapComponent), {
                                      modelValue: polygon.value,
                                      "onUpdate:modelValue": [
                                        _cache[23] || (_cache[23] = $event => ((polygon).value = $event)),
                                        _cache[24] || (_cache[24] = $event => (hasUnsavedChanges.value = true))
                                      ],
                                      class: _normalizeClass(!basics.value.map && 'opacity-30 pointer-events-none')
                                    }, null, 8, ["modelValue", "class"])
                                  ], 2))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_SettingsSection, {
                            title: `Eligible ${zipName.value}s`,
                            description: `Only customers with one of these ${zipName.value}s can choose this method.`
                          }, {
                            default: _withCtx(() => [
                              (eligibleZips.value.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eligibleZips.value, (zip) => {
                                      return (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _createTextVNode(_toDisplayString(zip) + " ", 1),
                                        _createVNode(_unref(XCircleIcon), {
                                          class: "h-5 w-5 cursor-pointer text-gray-500",
                                          onClick: $event => (removeZip(zip))
                                        }, null, 8, ["onClick"])
                                      ]))
                                    }), 256))
                                  ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_19, "All " + _toDisplayString(zipName.value) + "s are eligible", 1)),
                              (zoneLockNotes.value.zips)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(zoneLockNotes.value.zips), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createVNode(_component_InputField, {
                                      modelValue: addingZip.value,
                                      "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => ((addingZip).value = $event)),
                                      class: "flex-1 min-w-0",
                                      minlength: zipLength.value,
                                      placeholder: `${zipLength.value}-digit ${zipName.value}`,
                                      onKeydown: _cache[26] || (_cache[26] = _withKeys($event => (addZip()), ["enter"])),
                                      onInput: onZipInput
                                    }, null, 8, ["modelValue", "minlength", "placeholder"]),
                                    _createVNode(_component_NeueButton, {
                                      type: 
                        addingZip.value.length === zipLength.value && !eligibleZips.value.some(x => x === addingZip.value)
                          ? 'secondary'
                          : 'inactive'
                      ,
                                      onClick: addZip
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" + " + _toDisplayString(capitalizedZipName.value), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["type"])
                                  ]))
                            ]),
                            _: 1
                          }, 8, ["title", "description"]),
                          _createVNode(_component_SettingsSection, {
                            title: `Eligible ${stateLabel.value.toLowerCase()}s`,
                            description: `Only customers in one of these ${stateLabel.value.toLowerCase()}s can choose this method.`
                          }, {
                            default: _withCtx(() => [
                              (eligibleStates.value.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eligibleStates.value, (state) => {
                                      return (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                        _createTextVNode(_toDisplayString(stateName(state)) + " ", 1),
                                        _createVNode(_unref(XCircleIcon), {
                                          class: "h-5 w-5 cursor-pointer text-gray-500",
                                          onClick: $event => (removeState(state))
                                        }, null, 8, ["onClick"])
                                      ]))
                                    }), 256))
                                  ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_24, "All " + _toDisplayString(stateLabel.value.toLowerCase()) + "s are eligible", 1)),
                              (zoneLockNotes.value.states)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(zoneLockNotes.value.states), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                      _createVNode(_component_SelectInput, {
                                        modelValue: addingState.value,
                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => ((addingState).value = $event)),
                                        placeholder: "Choose a state",
                                        options: allStates.value.filter(x => !eligibleStates.value.some(y => y === x.value)),
                                        onKeydown: _cache[28] || (_cache[28] = _withKeys($event => (addState()), ["enter"]))
                                      }, null, 8, ["modelValue", "options"])
                                    ]),
                                    _createVNode(_component_NeueButton, {
                                      type: addingState.value ? 'secondary' : 'inactive',
                                      onClick: addState
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" + " + _toDisplayString(stateLabel.value), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["type"])
                                  ]))
                            ]),
                            _: 1
                          }, 8, ["title", "description"])
                        ], 64))
                  ], 512)), [
                    [_vShow, _unref(activeTab) === 'zones']
                  ])
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_28, [
                _createVNode(_component_SettingsSection, {
                  title: "Restrictions",
                  description: "Block membership tiers from ordering, or set a cart minimum for everyone or for one tier."
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_SelectInput, {
                          modelValue: addingRestriction.value,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => ((addingRestriction).value = $event)),
                          placeholder: "Choose a restriction type",
                          options: [
                        { name: 'Block a membership tier', value: 'tier' },
                        { name: 'Enforce a cart minimum', value: 'total' }
                      ]
                        }, null, 8, ["modelValue"])
                      ]),
                      _createVNode(_component_NeueButton, {
                        type: addingRestriction.value ? 'secondary' : 'inactive',
                        onClick: addRestriction
                      }, {
                        default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                          _createTextVNode(" + Restriction ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["type"])
                    ]),
                    (restrictions.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(restrictions.value, (restriction) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: restriction.id,
                              class: "flex items-center justify-between gap-4 py-3 text-sm text-gray-600"
                            }, [
                              (restriction.attributes.type_of_restriction === 'cart_total')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "min-w-0 flex-1 cursor-pointer",
                                    onClick: $event => (editRestriction(restriction))
                                  }, [
                                    _cache[51] || (_cache[51] = _createTextVNode(" Enforce ", -1)),
                                    _createElementVNode("span", _hoisted_33, _toDisplayString(restriction.attributes.integer_value_as_money.format), 1),
                                    _cache[52] || (_cache[52] = _createTextVNode(" cart minimum ", -1)),
                                    (restriction.attributes.restriction_id)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                          _cache[49] || (_cache[49] = _createTextVNode(" for ", -1)),
                                          _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(mapRelationship)({ type: 'membership_tier', id: restriction.attributes.restriction_id })
                              ?.attributes.tier_name), 1),
                                          _cache[50] || (_cache[50] = _createTextVNode(" members ", -1))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_32))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "min-w-0 flex-1 cursor-pointer",
                                    onClick: $event => (editRestriction(restriction))
                                  }, [
                                    _cache[53] || (_cache[53] = _createTextVNode(" Block ", -1)),
                                    _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(mapRelationship)({ type: 'membership_tier', id: restriction.attributes.restriction_id })
                            ?.attributes.tier_name), 1),
                                    _cache[54] || (_cache[54] = _createTextVNode(" members ", -1))
                                  ], 8, _hoisted_36)),
                              _createVNode(_unref(XCircleIcon), {
                                class: "h-5 w-5 shrink-0 cursor-pointer text-gray-700",
                                onClick: $event => (deleteRestriction(restriction))
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createBlock(_component_EmptyState, {
                          key: 1,
                          plural: "restrictions",
                          class: "border-t border-gray-100 pt-6 pb-2"
                        }))
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _unref(activeTab) === 'restrictions']
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_38, [
                _createVNode(_component_SettingsSection, {
                  title: "Reminders",
                  description: "Messages sent to customers with an order on this method, timed around the arrival day.",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    (reminders.value?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createVNode(_component_NeueTablist, null, {
                            head: _withCtx(() => [
                              _createVNode(_component_TablistHeader, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_TablistGrid, {
                                    columns: reminderColumns,
                                    header: "",
                                    class: "items-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[56] || (_cache[56] = _createElementVNode("div", null, "When", -1)),
                                      _cache[57] || (_cache[57] = _createElementVNode("div", null, "Message", -1)),
                                      _createElementVNode("div", _hoisted_40, [
                                        _createVNode(_component_NeueButton, {
                                          type: "secondary",
                                          onClick: addReminder
                                        }, {
                                          default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                            _createTextVNode("+ Reminder", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reminders.value, (reminder) => {
                                return (_openBlock(), _createBlock(_component_TablistRow, {
                                  key: reminder.id,
                                  class: "text-gray-700 cursor-pointer",
                                  onClick: $event => (openReminderModal(reminder))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_TablistGrid, {
                                      columns: reminderColumns,
                                      class: "items-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_41, _toDisplayString(reminderFormat(reminder)), 1),
                                        _createElementVNode("div", _hoisted_42, _toDisplayString(reminderTemplate(reminder)?.attributes.body), 1),
                                        _createElementVNode("div", _hoisted_43, [
                                          _createVNode(_unref(XCircleIcon), {
                                            class: "h-5 w-5 cursor-pointer text-gray-700",
                                            onClick: _withModifiers($event => (deleteReminder(reminder)), ["stop"])
                                          }, null, 8, ["onClick"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createBlock(_component_EmptyState, {
                          key: 1,
                          plural: "reminders",
                          class: "rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_NeueButton, {
                              type: "secondary",
                              onClick: addReminder
                            }, {
                              default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                _createTextVNode("+ Reminder", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _unref(activeTab) === 'reminders']
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_44, [
                _createVNode(_component_SettingsSection, {
                  title: "Checkout display",
                  description: "The order this method is listed in at checkout, and whether its times show."
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputField, {
                      modelValue: basics.value.order,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => ((basics.value.order) = $event)),
                      name: "Display order",
                      placeholder: "Enter number",
                      class: "sm:max-w-xs",
                      onInput: _cache[31] || (_cache[31] = $event => (hasUnsavedChanges.value = true))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_45, [
                      _cache[59] || (_cache[59] = _createElementVNode("div", { class: "min-w-0" }, [
                        _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Hide times"),
                        _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Hide order-by and fulfillment date/time text on checkout. ")
                      ], -1)),
                      _createVNode(_component_NeueToggle, {
                        modelValue: basics.value.hideTimes,
                        "onUpdate:modelValue": [
                          _cache[32] || (_cache[32] = $event => ((basics.value.hideTimes) = $event)),
                          _cache[33] || (_cache[33] = $event => (hasUnsavedChanges.value = true))
                        ]
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_SettingsSection, {
                  title: "Backup method",
                  description: "If this method has no slots during auto-selection, a slot from the backup method is picked for the customer."
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_SelectInput, {
                        modelValue: backup.value,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => ((backup).value = $event)),
                        name: "Backup fulfillment method",
                        options: backupOptions.value,
                        onChange: _cache[35] || (_cache[35] = $event => (hasUnsavedChanges.value = true))
                      }, null, 8, ["modelValue", "options"])
                    ])
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _unref(activeTab) === 'advanced']
              ])
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_TheModal, {
            "is-open": restrictionModalOpen.value,
            "modal-title": "Edit restriction",
            onCloseModal: closeRestrictionModal
          }, {
            main: _withCtx(() => [
              _createVNode(_component_FormSection, null, {
                default: _withCtx(() => [
                  (editingRestriction.value.type === 'membership_tier')
                    ? (_openBlock(), _createBlock(_component_FormElement, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SelectInput, {
                            modelValue: editingRestriction.value.tierId,
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => ((editingRestriction.value.tierId) = $event)),
                            options: tiers.value.map(x => ({ name: x.attributes.tier_name, value: x.id })),
                            name: "Membership tier to block",
                            placeholder: "Choose a membership tier"
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_SelectInput, {
                              modelValue: editingRestriction.value.tierId,
                              "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => ((editingRestriction.value.tierId) = $event)),
                              name: "Membership tier",
                              options: [
                        { name: '(No tier restriction)', value: null },
                        ...tiers.value.map(x => ({ name: x.attributes.tier_name, value: x.id }))
                      ]
                            }, null, 8, ["modelValue", "options"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_FormElement, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputField, {
                              modelValue: editingRestriction.value.cartValue,
                              "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => ((editingRestriction.value.cartValue) = $event)),
                              prefix: "$",
                              name: "Minimum cart value"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ], 64))
                ]),
                _: 1
              })
            ]),
            footer: _withCtx(() => [
              _createVNode(_component_NeueButton, {
                type: "secondary",
                onClick: closeRestrictionModal
              }, {
                default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_NeueButton, {
                type: editingRestriction.value.type === 'cart_total' || editingRestriction.value.tierId ? 'primary' : 'inactive',
                onClick: saveRestriction
              }, {
                default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                  _createTextVNode(" Save ", -1)
                ]))]),
                _: 1
              }, 8, ["type"])
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_TheModal, {
            "is-open": reminderModal.open,
            "modal-title": reminderModal.new ? 'Add reminder' : 'Edit reminder',
            "max-width": "max-w-2xl",
            onCloseModal: closeReminderModal
          }, {
            main: _withCtx(() => [
              _createVNode(_component_FormSection, { fullwidth: true }, {
                default: _withCtx(() => [
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _cache[63] || (_cache[63] = _createElementVNode("div", { class: "text-sm font-medium text-gray-700 mb-1" }, "Reminder time", -1)),
                      _createElementVNode("div", _hoisted_47, [
                        _cache[62] || (_cache[62] = _createTextVNode(" At ", -1)),
                        _createVNode(_component_InputField, {
                          modelValue: reminderModal.time,
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => ((reminderModal.time) = $event)),
                          type: "time",
                          class: "w-32"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_SelectInput, {
                          modelValue: reminderModal.multiplier,
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => ((reminderModal.multiplier) = $event)),
                          options: [
                        { name: 'this many days before the arrival day:', value: -1 },
                        { name: 'on the arrival day', value: 0 },
                        { name: 'this many days after the arrival day:', value: 1 }
                      ]
                        }, null, 8, ["modelValue"]),
                        (reminderModal.multiplier != 0)
                          ? (_openBlock(), _createBlock(_component_InputField, {
                              key: 0,
                              modelValue: reminderModal.days,
                              "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => ((reminderModal.days) = $event)),
                              class: "w-16"
                            }, null, 8, ["modelValue"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputArea, {
                        modelValue: reminderModal.body,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => ((reminderModal.body) = $event)),
                        name: "Reminder text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            footer: _withCtx(() => [
              _createVNode(_component_NeueButton, {
                type: "secondary",
                onClick: closeReminderModal
              }, {
                default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_NeueButton, {
                type: reminderModal.body ? 'primary' : 'inactive',
                onClick: saveReminderModal
              }, {
                default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                  _createTextVNode(" Save ", -1)
                ]))]),
                _: 1
              }, 8, ["type"])
            ]),
            _: 1
          }, 8, ["is-open", "modal-title"])
        ]),
        _createVNode(_component_PageFooter, null, {
          left: _withCtx(() => [
            _createVNode(_component_NeueButton, {
              type: "red",
              onClick: deleteMethod
            }, {
              default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                _createTextVNode("Delete", -1)
              ]))]),
              _: 1
            })
          ]),
          right: _withCtx(() => [
            (hasUnsavedChanges.value)
              ? (_openBlock(), _createBlock(_component_NeueButton, {
                  key: 0,
                  type: "primary",
                  onClick: submit
                }, {
                  default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                    _createTextVNode("Save", -1)
                  ]))]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_NeueButton, {
                  key: 1,
                  type: "primary",
                  onClick: _cache[43] || (_cache[43] = $event => (_unref(router).push('/store/fulfillment-methods')))
                }, {
                  default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                    _createTextVNode("Done", -1)
                  ]))]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

}